import React, { useState, useEffect } from 'react';

import ApplicationInfo from './ApplicationInfo';
import BurgerMenu from './burgerMenu/BurgerMenu';
import IwocaLogoRed from './IwocaLogoRed';
import MobileNavigation from './mobile/MobileNavigation';
import styles from './Navigation.module.css';
import SaveApplicationLink from '../SaveApplication/SaveApplicationLink';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

const Navigation = () => {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const mobileNavigation = windowDimensions.width < 1024;

    if (mobileNavigation) {
        return (
            <>
                <MobileNavigation isMobile={true} />
            </>
        );
    }

    return (
        <div className={styles.navigation} data-testid="navigation">
            <div className={styles.navigationContent}>
                <IwocaLogoRed />

                <ApplicationInfo />
            </div>
            <div className={styles.navItemsContainer}>
                <SaveApplicationLink />
                <BurgerMenu isMobile={false} />
            </div>
        </div>
    );
};

export default Navigation;
